export const AVAILABLE = 'AVAILABLE';
export const UNAVAILABLE = 'UNAVAILABLE';
export const AWAY = 'AWAY';

export const userAvailabilityTypes = [
  AVAILABLE,
  UNAVAILABLE,
  AWAY,
];
